// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-empty-state {
  border: 1px solid #adb3b8;
  text-align: center;
  margin: 0 20px;
}
.streams-drawer-empty-state-uploads-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.streams-drawer-empty-state-standard-image {
  max-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-content/streams-drawer-empty-state/streams-drawer-empty-state.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;AADF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAFF;AAKA;EACE,gBAAA;AAHF","sourcesContent":["@import (reference) '../../../../css/unison';\n\n.streams-drawer-empty-state {\n  border: 1px solid @cu-gray-5;\n  text-align: center;\n  margin: 0 20px;\n}\n\n.streams-drawer-empty-state-uploads-image {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n}\n\n.streams-drawer-empty-state-standard-image {\n  max-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
